import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehiculoIndexComponent } from './vehiculo-index/vehiculo-index.component';
import { VehiculoViewComponent } from './vehiculo-view/vehiculo-view.component';
import { VehiculoCreateComponent } from './vehiculo-create/vehiculo-create.component';
import { VehiculoUpdateComponent } from './vehiculo-update/vehiculo-update.component';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { VehiculoHistoricoComponent } from './vehiculo-historico/vehiculo-historico.component';

const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },
  { path: 'index', component: VehiculoIndexComponent },
];

@NgModule({
  declarations: [
    VehiculoIndexComponent,
    VehiculoViewComponent,
    VehiculoCreateComponent,
    VehiculoUpdateComponent,
    VehiculoHistoricoComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    NgbModalModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule,
  ]
})
export class VehiculoModule { }
